<template>
	<div class="content">
		<!-- 背景图片 -->
		<div class="login_bg"></div>
		<!-- 登录表单 -->
		<div class="login_form">
			<div class="left">
				<img class="image" src="@/assets/common/login_left.png">
			</div> 
			<div class="right">
				<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                    <!-- 账号登录 -->
				    <el-tab-pane label="账号登录" name="accountLogin">
						<div class="noteForm">
                            <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
                                <el-form-item prop="username">
                                    <!-- autocomplete="new-password" -->
									<el-input v-model="loginForm.username" placeholder="请输入用户名/手机号/邮箱"></el-input>
								</el-form-item>
                                <el-form-item prop="password">
									<el-input v-model="loginForm.password" @keyup.enter.native="goLogin" placeholder="请输入密码" show-password></el-input>
								</el-form-item>
                            </el-form>
							<el-button type="primary" @click="goLogin">登录</el-button>
						</div>
					</el-tab-pane>
                    <!-- 短信登录 -->
				    <el-tab-pane label="短信登录" name="codeLogin">
						<div class="noteForm">
							<el-form :model="noteForm" :rules="noteRules" ref="noteForm">
								<el-form-item prop="phoneNumber">
									<el-input v-model="noteForm.phoneNumber" @blur="checkPhone" clearable placeholder="请输入手机号"></el-input>
								</el-form-item>
								<el-form-item prop="verificationCode">
									<el-row>
											<el-col :span="16">
												<el-input v-model="noteForm.verificationCode" @keyup.enter.native="goLoginByNote" placeholder="请输入验证码"></el-input>
											</el-col>
											<el-col :span="8">
												<div @click="getCode" class="button" :class="{ disButton: disabled }">
														{{buttonName}}
												</div>
											</el-col>
									</el-row>
								</el-form-item>
						    </el-form>
							<el-button type="primary" @click="goLoginByNote">登录</el-button>
						</div>
					</el-tab-pane>
                    <div class="foot">
						<div class="text" @click="goRegister">立即注册</div><span>|</span>
						<div class="text" @click="forgetAct">忘记账号</div><span>|</span>
						<div class="text" @click="forgetPwd">忘记密码</div>
					</div>
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
    import { getVerificationCode, validVerificationCode } from '@/api/sms.js'
    export default {
        data() {
            const validateCode = (rule, value, callback) => {//rule:当前规则对象，value:需要进行校验的值，callback:验证之后执行的回调
                if (value == '') {
                    callback(new Error('请输入验证码'))
                } else if (value != this.correctCode) {
                    callback(new Error('验证码有误或已过期'))
                } else {
                    callback()
                }
            }
            return {
                activeName: 'accountLogin',
                // 账号登录
                loginForm: {
                    username: '',
                    password: '',
                },
                loginRules: {
                    username: [
                        { required: true,  message: '请输入用户名', trigger: 'blur' }, 
                    ],
                    password: [
                        { required: true,  message: '请输入密码', trigger: 'blur' }, 
                    ],
                },
                //短信登录
                noteForm: {
                    phoneNumber: '',
                    verificationCode: '',
                },
                noteRules: {
                    phoneNumber: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    verificationCode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                        { validator: validateCode, trigger: 'blur' }
                    ],
                },
                timer: null,
                count: 0,
                buttonName: '获取验证码',
                disabled: true,
                phoneChecked: false,
                correctCode: '',//正确验证码
            }
        },
        mounted() {
            //监听浏览器后退事件
            // if (window.history && window.history.pushState) {
            //     history.pushState(null, null, document.URL); //这里有没有都无所谓，最好是有以防万一
            //     window.addEventListener('popstate', this.popstate, false);
            //     // 回退时执行popstate方法
            // }
        },
        destroyed() {
            // window.removeEventListener('popstate', this.popstate, false);
        },
        watch: {
            //监听手机号输入
            'noteForm.phoneNumber': function(val) {
                if (val == '') {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
            }
        },
        methods: {
            // popstate() {
            //     this.$router.push({
            //         path: '/'
            //     })
            // },
            // tab栏切换
            handleClick() {
                if (this.loginForm.username == '' && this.loginForm.password == '') {
                    this.$refs['loginForm'].resetFields();
                }
                if (this.noteForm.phoneNumber == '') {
                    this.$refs['noteForm'].resetFields();
                }
            },
            //账号登录
            goLogin() {
                this.$refs['loginForm'].validate((valid) => {
                    if(valid) {
                        let loginForm = {
                            username: this.loginForm.username.trim(),
                            password: this.loginForm.password.trim()
                        }
                        this.$store.dispatch('user/login', loginForm).then(() => {
                            this.$router.push({
                                path: '/'
                            })  
                            this.$message.success("登录成功")
                        }).catch((error) => { // 异常
                            this.$message.error(error)
                        })
                    } else {
                        return false;
                    }
                })
            },
            //校验手机号输入是否正确
            checkPhone() {
                this.$refs['noteForm'].validateField('phoneNumber', (error) => {
                    if(!error) {
                        this.disabled = false;
                        this.phoneChecked = true;
                    } else {
                        this.disabled = true;
                        this.phoneChecked = false;
                        return false;
                    }
                })
            },
            //获取验证码
            getCode() {
                if (this.phoneChecked && this.count == 0) {
                    let param = {
                        phone: this.noteForm.phoneNumber.trim(),
                        status: '2',
                    }
                    getVerificationCode(param).then((res) => {
                        this.$message.success('验证码发送成功！');
                        this.getCorrectCode();
                        //验证码倒计时
                        if (!this.timer) {
                            this.count = 60;
                            this.disabled = true;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= 60) {
                                    this.count--;
                                    let nowCountDown = this.count;
                                    this.buttonName = `${nowCountDown}s 后重新发送`;
                                } else {
                                    this.disabled = false;
                                    this.buttonName = '获取验证码';
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000)
                        }
                    })
                } else {
                    return;
                }
            },
            //获取正确的短信验证码
            getCorrectCode() {
                let param = {
                    phone: this.noteForm.phoneNumber.trim(),
                    status: '2',
                }
                validVerificationCode(param).then(res => {
                    this.correctCode = res.data;
                })
            },
            //短信登录
            goLoginByNote() {
                this.$refs['noteForm'].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch('user/textLogin', this.noteForm).then(() => {
                            this.$router.push({path: '/'})
                            this.$message.success("登录成功")
                        }).catch((error) => { // 异常
                            this.$message.error(error)
                        })
                    } else {
                        return false;
                    }
                })
            },
            goRegister() {
                this.$router.push({path: '/register'})
            },
            forgetAct() {
                this.$router.push({path: '/forgetAccount'})
            },
            forgetPwd() {
                this.$router.push({path: '/forgetPassword'})
            }
        }
    }
</script>
<style lang="scss">
    .login_form .right {
        .el-tabs__item {
            width: 210px;
            height: 60px;
            padding: 0;
            color: #c5ccdb;
            font-size: 20px;
            line-height: 60px;
            text-align: center;
        }
        .el-tabs__item.is-active {
            color: #456cff;
        }
        .el-tabs__active-bar {
            background-color: #456cff;
        }
        .el-input {
            margin-top: 30px;
        }
        .el-input__inner:focus {
            border-color: #456cff;
        }
        .el-button {
            width: 100%;
            height: 56px;
            margin-top: 56px;
            border-radius: 8px;
            background-color: #5984EC;
            font-size: 20px;
        }
    }
</style>
<style lang="scss" scoped="scoped">
    .content {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        min-width: 1200px;
        min-height: 820px;
        display: flex;
        justify-content: center;
        align-items: center;
        .login_bg {
            width: 100%;
            height: 100%;
            min-width: 1200px;
            zoom: 1;
            z-index: -10;
            top: 0;
            left: 0;
            position: fixed;
            background: url('../../assets/common/login_background.png') no-repeat;
            background-color: #fff;
            background-size: cover;
            -webkit-background-size: cover;
            -o-background-size: cover;
            background-position: center 0;
        }
        .login_form {
            width: 1000px;
            height: 620px;
            display: flex;
            background-color: #FFFFFF;
            box-shadow: 0px 0px 20px 10px #d0d2d5;
            .left .image {
                width: 380px;
                height: 620px;
            }
            .right {
                width: 100%;
                padding: 100px;
                .foot {
                    color: #848b99;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    .text {
                        margin: 0 20px;
                    }
                    .text:hover {
                        cursor: pointer;
                        color: #456cff;
                    }
                }
            }
        }
    }
    
    .noteForm {
        margin-top: 50px;
    }
    
    .noteForm .el-input {
        margin-top: 10px;
    }
    
    .login_form .right .el-button {
        margin: 30px 0 40px;
    }

    .button {
        width: 90%;
        height: 40px;
        margin: 10px 0 0 10%;
        border: none;
        background-color: #5984EC;
        font-size: 12px;
        color: #fff;
        text-align: center;
        border-radius: 6px;
    }
    
    .button:hover {
        cursor: pointer;
    }
    
    .disButton {
        background-color: #ECECEC;
        color: #AAA;
    }
    
    .disButton:hover {
        cursor: not-allowed;
    }
</style>